export enum REQUEST_TYPE {
  JUSTIFIED = 'JUSTIFIED',
  UNJUSTIFIED = 'UNJUSTIFIED',
  LEAVE = 'LEAVE',
  EXCEPTIONAL_LEAVE = 'EXCEPTIONAL_LEAVE',
  SICK_LEAVE = 'SICK_LEAVE',
  OVERTIME = 'OVERTIME',
  MATERNITY_LEAVE = 'MATERNITY LEAVE',
}

export enum CNPS_DECLARATION_TYPE {
  INITIAL = 'INITIAL',
  COMPLEMENTARY = 'COMPLEMENTARY',
}

export enum REQUEST_STATUS {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED',
}
export enum MEMBER_TYPES {
  ADMIN = 'ADMIN',
  ACCOUNTANT = 'ACCOUNTANT',
  STAFF = 'STAFF',
}

export enum STAFF_REQUEST_PROCESS_STATUS {
  ADMIN_PENDING = 'ADMIN_PENDING',
  ADMIN_APPROVED = 'ADMIN_APPROVED',
  ADMIN_DECLINED = 'ADMIN_DECLINED',
  STAFF_PENDING = 'STAFF_PENDING',
  STAFF_APPROVED = 'STAFF_APPROVED',
  STAFF_DECLINED = 'STAFF_DECLINED',
}

export const GET_DESIGNATED_STAFF_REQUEST_TEMPLATES = (
  processStatus: STAFF_REQUEST_PROCESS_STATUS,
): string => {
  let result = '';

  switch (processStatus) {
    case STAFF_REQUEST_PROCESS_STATUS.ADMIN_PENDING:
      result = process.env['ADMIN_CREATE_STAFF_REQUEST_TEMPLATE_KEY'] || '';
      break;
    case STAFF_REQUEST_PROCESS_STATUS.ADMIN_APPROVED:
      result = process.env['ADMIN_APPROVAL_STAFF_REQUEST_TEMPLATE_KEY'] || '';
      break;
    case STAFF_REQUEST_PROCESS_STATUS.ADMIN_DECLINED:
      result = process.env['ADMIN_DENIAL_STAFF_REQUEST_TEMPLATE_KEY'] || '';
      break;
    case STAFF_REQUEST_PROCESS_STATUS.STAFF_APPROVED:
      result = process.env['STAFF_APPROVAL_STAFF_REQUEST_TEMPLATE_KEY'] || '';
      break;
    case STAFF_REQUEST_PROCESS_STATUS.STAFF_PENDING:
      result = process.env['STAFF_CREATE_STAFF_REQUEST_TEMPLATE_KEY'] || '';
      break;
    case STAFF_REQUEST_PROCESS_STATUS.STAFF_DECLINED:
      result = process.env['STAFF_DENIAL_STAFF_REQUEST_TEMPLATE_KEY'] || '';
      break;
  }
  return result;
};

export const GET_DESIGNATED_STAFF_REQEST_TEMPLATES: Map<
  STAFF_REQUEST_PROCESS_STATUS,
  string
> = new Map([
  [
    STAFF_REQUEST_PROCESS_STATUS.ADMIN_PENDING,
    process.env['ADMIN_CREATE_STAFF_REQUEST_TEMPLATE_KEY'] || '',
  ],
  [
    STAFF_REQUEST_PROCESS_STATUS.ADMIN_APPROVED,
    process.env['ADMIN_APPROVAL_STAFF_REQUEST_TEMPLATE_KEY'] || '',
  ],
  [
    STAFF_REQUEST_PROCESS_STATUS.ADMIN_DECLINED,
    process.env['ADMIN_DENIAL_STAFF_REQUEST_TEMPLATE_KEY'] || '',
  ],
  [
    STAFF_REQUEST_PROCESS_STATUS.STAFF_APPROVED,
    process.env['STAFF_APPROVAL_STAFF_REQUEST_TEMPLATE_KEY'] || '',
  ],
  [
    STAFF_REQUEST_PROCESS_STATUS.STAFF_PENDING,
    process.env['STAFF_CREATE_STAFF_REQUEST_TEMPLATE_KEY'] || '',
  ],
  [
    STAFF_REQUEST_PROCESS_STATUS.STAFF_DECLINED,
    process.env['STAFF_DENIAL_STAFF_REQUEST_TEMPLATE_KEY'] || '',
  ],
]);
